import React from 'react';

interface AuthPageShellProps {
  children: React.ReactNode;
}

const AuthPageShell: React.FC<AuthPageShellProps> = ({ children }) => {
  return (
    <div className="flex-1 flex flex-col items-center justify-center relative overflow-hidden bg-white dark:bg-gray-900 px-4 py-8">
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-0 left-[30%] w-[80vw] h-[80vw] max-w-3xl rounded-full bg-purple-500/10 dark:bg-purple-500/5 blur-3xl animate-pulse" />
        <div className="absolute bottom-0 right-[10%] w-64 h-64 rounded-full bg-pink-500/10 blur-3xl" />
      </div>
      <main className="w-full max-w-[400px] relative z-10">{children}</main>
    </div>
  );
};

export default AuthPageShell;
